import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-[var(--border-color)] bg-[var(--bg-primary)] py-5 sm:py-6">
      <div className="mx-auto w-full px-4 text-center sm:px-6 lg:px-8" style={{ maxWidth: 'var(--layout-max-width)' }}>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm text-[var(--text-secondary)]">
          <a
            href="https://healthchip.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-[var(--primary-color)] no-underline hover:text-[var(--primary-hover)]"
          >
            Powered by HealthChip
          </a>
          <span className="text-[var(--border-color)]">|</span>
          <Link to="/user/help" className="font-medium text-[var(--text-secondary)] no-underline hover:text-[var(--primary-color)]">
            Help
          </Link>
          <span className="text-[var(--border-color)]">|</span>
          <Link to="/legal/terms" className="font-medium text-[var(--text-secondary)] no-underline hover:text-[var(--primary-color)]">
            Terms
          </Link>
          <span className="text-[var(--border-color)]">|</span>
          <Link to="/legal/privacy" className="font-medium text-[var(--text-secondary)] no-underline hover:text-[var(--primary-color)]">
            Privacy
          </Link>
          <span className="text-[var(--border-color)]">|</span>
          <Link to="/legal/cookies" className="font-medium text-[var(--text-secondary)] no-underline hover:text-[var(--primary-color)]">
            Cookies
          </Link>
        </div>
        <p className="m-0 mt-1 text-[var(--text-secondary)] text-sm">
          &copy; {currentYear} HealthChip. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
